import { render, staticRenderFns } from "./PrintingMachine.vue?vue&type=template&id=61709b3e&scoped=true&"
import script from "./PrintingMachine.vue?vue&type=script&lang=js&"
export * from "./PrintingMachine.vue?vue&type=script&lang=js&"
import style0 from "./PrintingMachine.vue?vue&type=style&index=0&id=61709b3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61709b3e",
  null
  
)

export default component.exports